import { cn } from "@/lib/utils";
import { formatCountdownLive } from "@/lib/countdown";
import { useLiveCountdown } from "@/hooks/useLiveCountdown";

/**
 * Texte de décompte (rafraîchi chaque seconde).
 * @param {string} targetIso — date/heure de fin
 * @param {string} [prefix] — ex. « Reste : »
 * @param {string} [doneLabel] — affiché quand le délai est écoulé
 */
export default function LiveCountdown({
  targetIso,
  prefix = "",
  doneLabel = "Délai écoulé",
  className,
  tabular = true,
}) {
  const { remainingMs, done } = useLiveCountdown(targetIso);

  if (!targetIso || remainingMs == null) return null;

  const text = done ? doneLabel : `${prefix}${formatCountdownLive(remainingMs)}`;

  return (
    <span
      className={cn(tabular && "tabular-nums", className)}
      aria-live="polite"
      data-testid="live-countdown"
    >
      {text}
    </span>
  );
}
